import {
  MINIMUM_DNI_LENGTH,
  MAXIMUM_DNI_LENGTH,
  LIMIT_SHOW_CEDULA,
  MINIMUM_TELEPHONE_LENGTH,
  USER_MIN_LENGTH_PASSWORD,
  USER_MIN_LENGTH_LASTNAME,
  USER_MIN_LENGTH_NAME,
  INSURANCE_WITH_PLAN
} from '../libraries/constants';
import {
  INCORRECT_NEGATIVE_AMOUNT_TEXT,
  INCORRECT_MINIMUN_DNI_CHARACTERS_TEXT,
  INCORRECT_EMAIL_TEXT,
  IS_REQUIRED_TEXT,
  INCORRECT_CEDULA_TEXT,
  INCORRECT_PHONE_NUMBER,
  INCORRECT_EQUAL_PHONE_NUMBER,
  INCORRECT_MINIMUM_CHARACTERS,
  INCORRECT_CONFIRM_PASSWORD,
  INCORRECT_MINIMUM_CHARACTERS_PASSWORD,
  AMOUNT_IS_LOWER,
  SAME_AVAL_SUSCRIPTOR
} from '../libraries/texts';

import { cleanCharacters } from '../libraries/formatters';

const emailRegex = /[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+[.]{1}[A-Za-z]{2,64}/;

const alphaNumeric = /[^a-zA-Z0-9]/;

const numeric = /[^0-9]/;

const cedulaRegex = /^A{0,1}[0-9]{9}$/;

const passwordNumberRegex = /[0-9]+/;
const passwordLetterRegex = /[a-zA-Z]+/;
/* eslint-disable  no-useless-escape */
const passwordSymbolRegex = /[-!$@#%^&*()_+|~=`{}\[\]:";'<>?,.\/]+/;

const sameNumberRegex = /^(\d)\1*$/;

export const allowAphaNumeric = value => value.replace(alphaNumeric, '');

export const allowNumeric = value => value.replace(numeric, '');

export const isRequired = (errors, values) => {
  for (const [key, value] of Object.entries(values)) {
    if (value === 0) {
      continue;
    }

    if (!value || value === '' || value === 'NaN') {
      errors[key] = 'El campo es requerido';
    }
  }
  return errors;
};

export const isValidEmail = email => !email || emailRegex.test(email.trim());

export const isValidPasswordSymbol = password =>
  !password ||
  (passwordNumberRegex.test(`${password}`.trim()) &&
    passwordLetterRegex.test(`${password}`.trim()) &&
    passwordSymbolRegex.test(`${password}`.trim()));

export const isValidDni = dni => !(dni && dni.toString().length < MINIMUM_DNI_LENGTH);

export const isValidBudgetAmount = budgetAmount => !(budgetAmount <= 0);

export const isValidMinimumDNI = value => value < MAXIMUM_DNI_LENGTH;

export const isValidMinimum = (value, minimum) => value && value.toString().length >= minimum;

export const isValidCedula = value => !value || cedulaRegex.test(value.toString().trim());

export const isAllTheSameDigit = value => !value || sameNumberRegex.test(`${value}`.trim());

export const isMultiplesSelectorsRequired = (errors, values) => {
  for (const [key, value] of Object.entries(values)) {
    if (!value || !value.filter(elem => elem && elem.code).length > 0) {
      errors[key] = 'El campo es requerido';
    }
  }
  return errors;
};

export const isValidServiceForm = (errors, values) => {
  const { budgetAmount, amount } = values;
  if (!isValidBudgetAmount(budgetAmount)) {
    errors.budgetAmount = INCORRECT_NEGATIVE_AMOUNT_TEXT;

    if (amount && amount > budgetAmount) {
      errors.amount = AMOUNT_IS_LOWER;
    }
  }

  if (budgetAmount && amount && amount > budgetAmount) {
    errors.amount = AMOUNT_IS_LOWER;
  }
};

export const isValidPatientForm = (errors, values) => {
  const name = 'patient';
  const planSection = 'patientPlanSection';
  const dniField = `${name}Dni`;
  const patientInsurance = 'patientInsurance';
  if (values[dniField] === 'NaN' || values[dniField] === '') {
    errors[dniField] = 'El campo es requerido';
  }
  if (values[dniField] !== 'NaN' && !isValidDni(values[dniField])) {
    errors[dniField] = INCORRECT_MINIMUN_DNI_CHARACTERS_TEXT;
  }

  if (
    values[patientInsurance] &&
    values[patientInsurance].name === INSURANCE_WITH_PLAN &&
    !values[planSection]
  ) {
    errors[planSection] = IS_REQUIRED_TEXT;
  }
};

const addErrorForm = (errors, values, name) => {
  const emailField = `${name}Email`;
  const dniField = `${name}Dni`;
  const cedulaField = `${name}Cedula`;
  const phoneField1 = `${name}Tel1`;
  const phoneField2 = `${name}Tel2`;

  if (!isValidEmail(values[emailField])) {
    errors[emailField] = INCORRECT_EMAIL_TEXT;
  }

  if (values[dniField] === 'NaN') {
    errors[dniField] = IS_REQUIRED_TEXT;
  }

  if (values[dniField] && values[dniField] !== 'NaN' && !isValidDni(values[dniField])) {
    errors[dniField] = INCORRECT_MINIMUN_DNI_CHARACTERS_TEXT;
  }

  if (
    values[dniField] &&
    parseInt(values[dniField]) < LIMIT_SHOW_CEDULA &&
    isValidDni(values[dniField])
  ) {
    if (values[dniField] && !isValidMinimumDNI(values[dniField]) && !values[cedulaField]) {
      errors[cedulaField] = IS_REQUIRED_TEXT;
    }

    if (values[cedulaField] && !isValidCedula(cleanCharacters(values[cedulaField]))) {
      errors[cedulaField] = INCORRECT_CEDULA_TEXT;
    }
  }

  if (values[phoneField1] && values[phoneField2] && values[phoneField2] === values[phoneField1]) {
    errors[phoneField2] = INCORRECT_EQUAL_PHONE_NUMBER;
  }
  if (values[phoneField1] === 0 && `${values[phoneField1]}`.length >= 1) {
    errors[phoneField1] = INCORRECT_PHONE_NUMBER;
  }
  if (
    values[phoneField1] &&
    (!isValidMinimum(values[phoneField1], MINIMUM_TELEPHONE_LENGTH) ||
      isAllTheSameDigit(values[phoneField1]))
  ) {
    errors[phoneField1] = INCORRECT_PHONE_NUMBER;
  }

  if (values[phoneField2] === 0 && `${values[phoneField2]}`.length >= 1) {
    errors[phoneField2] = INCORRECT_PHONE_NUMBER;
  }

  if (
    values[phoneField2] &&
    (!isValidMinimum(values[phoneField2], MINIMUM_TELEPHONE_LENGTH) ||
      isAllTheSameDigit(values[phoneField2]))
  ) {
    errors[phoneField2] = INCORRECT_PHONE_NUMBER;
  }
};

export const isValidSubscriptorForm = (errors, values) => {
  addErrorForm(errors, values, 'suscriptor');
};

export const isValidAvalForm = (errors, values) => {
  addErrorForm(errors, values, 'aval');
  const dniField = `avalDni`;
  const suscriptorDniField = `suscriptorDni`;
  const dniValue = values[dniField].replace('NaN', '');
  const suscriptorDniValue = values[suscriptorDniField].replace('NaN', '');
  if (dniValue && suscriptorDniValue && dniValue === suscriptorDniValue) {
    errors[dniField] = SAME_AVAL_SUSCRIPTOR;
  }
};

export const checkPassword = (errors, values, passwordField) => {
  if (
    values[passwordField] &&
    (!isValidMinimum(values[passwordField], USER_MIN_LENGTH_PASSWORD) ||
      !isValidPasswordSymbol(values[passwordField]))
  ) {
    errors[passwordField] = INCORRECT_MINIMUM_CHARACTERS_PASSWORD(USER_MIN_LENGTH_PASSWORD);
  }
};

export const validPassword = (password, confirmpassword) =>
  password &&
  confirmpassword &&
  isValidMinimum(password, USER_MIN_LENGTH_PASSWORD) &&
  isValidMinimum(confirmpassword, USER_MIN_LENGTH_PASSWORD);

export const isValidUser = (errors, values) => {
  const nameField = 'name';
  const lastNameField = 'lastName';
  const emailField = 'username';
  const passwordField = 'password';
  const confirmPasswordField = 'confirmPassword';
  const dniField = 'rut';

  if (
    values[passwordField] &&
    (!isValidMinimum(values[passwordField], USER_MIN_LENGTH_PASSWORD) ||
      !isValidPasswordSymbol(values[passwordField]))
  ) {
    errors[passwordField] = INCORRECT_MINIMUM_CHARACTERS_PASSWORD(USER_MIN_LENGTH_PASSWORD);
  }

  if (
    values[confirmPasswordField] &&
    (!isValidMinimum(values[confirmPasswordField], USER_MIN_LENGTH_PASSWORD) ||
      !isValidPasswordSymbol(values[confirmPasswordField]))
  ) {
    errors[confirmPasswordField] = INCORRECT_MINIMUM_CHARACTERS_PASSWORD(USER_MIN_LENGTH_PASSWORD);
  }
  if (
    values[passwordField] &&
    validPassword(values[passwordField], values[confirmPasswordField]) &&
    values[passwordField] !== values[confirmPasswordField]
  ) {
    errors[confirmPasswordField] = INCORRECT_CONFIRM_PASSWORD;
  }
  if (!isValidDni(values[dniField])) {
    errors[dniField] = INCORRECT_MINIMUN_DNI_CHARACTERS_TEXT;
  }
  if (values[dniField] === 'NaN') {
    errors[dniField] = IS_REQUIRED_TEXT;
  }
  if (!isValidEmail(values[emailField])) {
    errors[emailField] = INCORRECT_EMAIL_TEXT;
  }

  if (values[nameField] && !isValidMinimum(values[nameField], USER_MIN_LENGTH_NAME)) {
    errors[nameField] = INCORRECT_MINIMUM_CHARACTERS(USER_MIN_LENGTH_NAME);
  }

  if (values[lastNameField] && !isValidMinimum(values[lastNameField], USER_MIN_LENGTH_LASTNAME)) {
    errors[lastNameField] = INCORRECT_MINIMUM_CHARACTERS(USER_MIN_LENGTH_LASTNAME);
  }
};

export const removeErrors = (errors, values, prefix) => {
  for (const val of Object.entries(values)) {
    const key = val[0];
    if (key.includes(prefix)) {
      delete errors[key];
    }
  }
};

export const unTouch = (touches, prefix) => {
  const touchList = Object.entries(touches);
  if (touchList.length === 0) return;
  for (const val of Object.entries(touches)) {
    const key = val[0];
    if (key.includes(prefix)) {
      touches[key] = false;
    }
  }
};
